interface DrWeedyLogoProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export default function DrWeedyLogo({
  width = 40,
  height = 40,
  className = "",
}: DrWeedyLogoProps) {
  return (
    <img
      src="/dr-weedy-logo-clean.png"
      alt="Dr. Weedy"
      width={width}
      height={height}
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}
